import React from 'react';
import { ChangeHistoryDetailModel } from "./models/change.history.detail.model";
import { Editor } from "../../../../src/shared";
import { DETAIL_KEYS } from "./constants/labels";

interface DescriptionProps {
  result: ChangeHistoryDetailModel;
}

export const AccountChangeHistoryDescription: React.FC<DescriptionProps> = ({ result }) => {
  if (!result) return null;

  const formatValue = (val: any) => {
    if (val === null || val === undefined || val === "") return "N/A";

    if (typeof val === "object") return JSON.stringify(val, null, '\t');

    return val.toString();
  };

  const buildObjectChangesText = (changes: any): string => {
    if (!changes) return "";

    const lines: string[] = [];

    Object.keys(changes).forEach((key) => {
      const value = changes[key];

      if (Array.isArray(value) && value.length === 2) {
        const oldVal = value[0];
        const newVal = value[1];

        lines.push(
          `${key}:`,
          `\t${DETAIL_KEYS.OLD_VAL}: ${formatValue(oldVal)}`,
          `\t${DETAIL_KEYS.NEW_VAL}: ${formatValue(newVal)}`,
          ``
        );
      }
    });

    return lines.join("\n");
  };

  const buildDescriptionText = (result: ChangeHistoryDetailModel): string => {
    let description = [
      `Account Changes:`,
      `-----------------------`,
      `${DETAIL_KEYS.ACCOUNT_ID}: ${result.item_id}`,
      `${DETAIL_KEYS.TYPE}: ${result.item_type}`,
      `${DETAIL_KEYS.EVENT}: ${result.event}`,
      ``
    ].join("\n");

    // append object_changes
    description += buildObjectChangesText(result.object_changes);

    return description;
  };

  const descriptionText = buildDescriptionText(result);

  return <Editor StringData={descriptionText} FormateType="json" />;
};